// paginations.js
'use strict';
import { fromJS } from 'immutable';
import {
  SET_PAGINATION_ITEMS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Pagination data.
 * @module reducer/paginations
 */
const paginations = (state = defaultState, action) => {
  switch (action.type) {
    case SET_PAGINATION_ITEMS:
      return _SET_PAGINATION_ITEMS(action.payload)(state);
    default:
      return state;
  }
};

/**
 * Set list items
 * @kind reducer/actionType
 * @name SET_PAGINATION_ITEMS
 * @param {array} {selectPath} - select path
 * @param {array} {itemIds} - item ids
 * @param {number} {page} - page
 * @param {number} {limit} - limit
 * @param {number} {totalCount} - items total count
 * @return {Immutable.Map} New state
 */
const _SET_PAGINATION_ITEMS =
  ({
    selectPath = [`unknown-${Math.random()}`],
    itemIds = [],
    page = 1,
    limit = 20,
    totalCount = 0,
  }) =>
  state => {
    const itemIdMap = itemIds.reduce((ids, id, index) => {
      ids[limit * (page - 1) + index] = id;
      return ids;
    }, {});
    return state.mergeDeepIn(selectPath, {
      page,
      limit,
      totalCount,
      itemIds: fromJS(itemIdMap),
    });
  };

export default paginations;
